import { TrackerConfig, TrackerExclusionRule } from '@ps/survey-utils';
import { TrackerConfigFormValues } from '../tracker-config-drawer.types';
import { TRACKER_CONFIG_DRAWER_FORM_DEFAULTS } from './tracker-config-drawer.schema';

/**
 * Maps the form values into the shared `TrackerConfig` domain shape when the user confirms the form.
 * The value fallbacks below never actually trigger (the schema guarantees these fields are non-null once
 * the form is valid, which is the only time this mapper runs) but the type
 * is still `Nullable<number>`, so a fallback is needed to satisfy it.
 */
export function toTrackerConfig(
  values: TrackerConfigFormValues,
): TrackerConfig {
  return {
    numberOfWaves:
      values.numberOfWaves ?? TRACKER_CONFIG_DRAWER_FORM_DEFAULTS.numberOfWaves,
    frequency: {
      amount:
        values.waveFrequencyAmount ??
        TRACKER_CONFIG_DRAWER_FORM_DEFAULTS.waveFrequencyAmount,
      unit: values.waveFrequencyUnit,
    },
    exclusionRule: toExclusionRule(values),
  };
}

function toExclusionRule(
  values: TrackerConfigFormValues,
): TrackerExclusionRule {
  const { exclusionRuleKind } = values;

  if (exclusionRuleKind === 'custom') {
    return {
      kind: 'custom',
      wavesExclude:
        values.customWavesExclude ??
        TRACKER_CONFIG_DRAWER_FORM_DEFAULTS.customWavesExclude,
    };
  }

  return { kind: exclusionRuleKind };
}
